import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MetricsSection } from './components/MetricsSection';
import { VisionSection } from './components/VisionSection';
import { ProgramIntro } from './components/ProgramIntro';
import { HowItWorks } from './components/HowItWorks';
import { CurriculumSection } from './components/CurriculumSection';
import { BonusSection } from './components/BonusSection';
import { ReviewsSection } from './components/ReviewsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { CTAButton } from './components/CTAButton';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MetricsSection data-id="element-3" />
      <VisionSection data-id="element-4" />
      <ProgramIntro data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <CurriculumSection data-id="element-7" />

      {/* Strategic CTA after curriculum */}
      <section className="w-full bg-blue-50 py-12" data-id="element-8">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-9">
          <p className="text-2xl font-bold text-gray-900 mb-6" data-id="element-10">
            ¿Listo para dominar Meta Ads desde cero?
          </p>
          <a href="#pricing" className="inline-block" data-id="element-11">
            <CTAButton size="large" data-id="element-12">Ver Precio Especial →</CTAButton>
          </a>
        </div>
      </section>

      <BonusSection data-id="element-13" />
      <ReviewsSection data-id="element-14" />
      <ForWhoSection data-id="element-15" />
      <ComparisonSection data-id="element-16" />
      <ObjectionsSection data-id="element-17" />
      <DeliverablesSection data-id="element-18" />

      {/* Footer */}
      <footer className="w-full bg-gray-900 text-gray-400 py-8" data-id="element-19">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-20">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-21">
            <svg className="w-6 h-6 text-[#0866FF]" viewBox="0 0 24 24" fill="currentColor" data-id="element-22">
              <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z" data-id="element-23" />
            </svg>
            <span className="font-semibold text-white" data-id="element-24">
              Meta Ads Desde Cero
            </span>
          </div>
          <p className="text-sm" data-id="element-25">
            © {new Date().getFullYear()} Curso en vivo para principiantes.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}